module.exports = __webpack_public_path__ + "assets/signed.7a297ddbad38528c854cda55b5ec630b.png";